import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-providers',
  templateUrl: './card-providers.component.html',
  styleUrls: ['./card-providers.component.scss']
})
export class CardProvidersComponent {
  @Input() provider!: any;
  constructor(private router: Router){}

  providerDetail(provider: any){
    let queryParams: any = {};
    const currentCategories = provider?.categories || [];
    if(currentCategories.length > 0){
      queryParams = {
        idCategory: currentCategories[0]._id
      }
    }
    
    this.router.navigate(['/home/result'], { 
      queryParams: { 
        idProvider: provider._id,
      } 
    });
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/new_placeholder.png';
  }
  
  isProviderDemo(){
    return Object.keys(this.provider).length == 0;
  }
}
